import {pluralNumber} from '../../../utils/numerals/pluralNumber';

const HIDE_CLASS = `hide`;

const getTimeRemaining = (deadlineArray) => {
	const total = new Date(...deadlineArray) - new Date();
	const days = Math.floor( (total/(1000*60*60*24)) );
	const hours = Math.floor( (total/(1000*60*60) % 24) );
	const minutes = Math.floor( (total/1000/60) % 60 );
	const seconds = Math.floor( (total/1000 % 60) );
	
	return {
		total,
		days,
		hours,
		minutes,
		seconds,
	};
};

const getZero = (num) => num >= 0 && num < 10 ? `0${num}` : num;

export const setTimer = (sidebar, deadline, container) => {
    const deadlineArray = deadline.replace(/\D/g,` `).split(` `);
    deadlineArray[1] -= 1;

	initTimer( container, deadlineArray, sidebar );
};

const TIMER_CONTER_TEMPLATE = (`
	<div class="time-counter">
		<div class="time-cell days">
			<span class="value"></span>
			<span class="key"></span>
		</div>
		<div class="time-delimiter"></div>
		<div class="time-cell hours">
			<span class="value"></span>
			<span class="key"></span>
		</div>
		<div class="time-delimiter"></div>
		<div class="time-cell minutes">
			<span class="value"></span>
			<span class="key"></span>
		</div>
		<div class="time-delimiter hide"></div>
		<div class="time-cell seconds hide">
			<span class="value"></span>
			<span class="key"></span>
		</div>
	</div>
`);

const formatTimeValue = ( value ) => {
	return `${value}`.padStart( 2, `0` );
};

const initTimer = ( oldNode, deadlineArray, sidebar ) => {
	const wrapper = document.createElement( `div` );
	wrapper.innerHTML = TIMER_CONTER_TEMPLATE;
	
	const container = wrapper.firstElementChild;
	
	const daysCell = container.querySelector( `.time-cell.days` );
	const daysValueNode = daysCell.querySelector( `.value` );
	const daysKeyNode = daysCell.querySelector( `.key` );
	const daysDelimiter = daysCell.nextElementSibling;
	
	const hoursValueNode = container.querySelector( `.time-cell.hours > .value` );
	const hoursKeyNode = container.querySelector( `.time-cell.hours > .key` );
	
	const minutesCell = container.querySelector( `.time-cell.minutes` );
	const minutesValueNode = minutesCell.querySelector( `.value` );
	const minutesKeyNode = minutesCell.querySelector( `.key` );
	
	const secondsCell = container.querySelector( `.time-cell.seconds` );
	const secondsValueNode = secondsCell.querySelector( `.value` );
	const secondsKeyNode = secondsCell.querySelector( `.key` );
	const secondsDelimiter = minutesCell.nextElementSibling;
	
	const timeValueNodes = [daysValueNode, hoursValueNode, minutesValueNode, secondsValueNode];
	
	const adjustFontSize = () => {
		if ( container.offsetWidth < container.scrollWidth )
		{
			let size = daysValueNode.style.fontSize
				? parseInt( daysValueNode.style.fontSize, 10 )
				: parseInt( window.getComputedStyle( daysValueNode ).fontSize, 10 );
			
			while ( size > 10 && container.offsetWidth < container.scrollWidth )
			{
				size--;
				timeValueNodes.forEach( ( valueNode ) => {
					valueNode.style.setProperty( `font-size`, `${size}px` )
				} );
			}
		}
	}
	
	const handleChangeSize = () => {
		if ( container.offsetWidth < container.scrollWidth )
		{
			adjustFontSize();
		}
		else if ( daysValueNode.style.fontSize )
		{
			timeValueNodes.forEach( ( valueNode ) => {
				valueNode.style.removeProperty( `font-size` );
			} );
			
			adjustFontSize();
		}
	};
	
	const displaySecondsCell = () => {
		let isEdit = false;
		
		if ( secondsCell.classList.contains( HIDE_CLASS ) )
		{
			secondsCell.classList.remove( HIDE_CLASS );
			isEdit = true;
		}
		
		if ( secondsDelimiter.classList.contains( HIDE_CLASS ) )
		{
			secondsDelimiter.classList.remove( HIDE_CLASS );
			isEdit = true;
		}
		
		if ( isEdit )
		{
			handleChangeSize();
		}
	};
	
	const hideDaysCell = () => {
		let isEdit = false;
		
		if ( !daysCell.classList.contains( HIDE_CLASS ) )
		{
			daysCell.classList.add( HIDE_CLASS );
			isEdit = true;
		}
		
		if ( !daysDelimiter.classList.contains( HIDE_CLASS ) )
		{
			daysDelimiter.classList.add( HIDE_CLASS );
			isEdit = true;
		}
		
		if ( isEdit )
		{
			handleChangeSize();
		}
	};
	
	const updateTimer = () => {
		const timeData = getTimeRemaining(deadlineArray);
		
		if (timeData.total <= 0) {
			sidebar.style.display = `none`;
			return clearInterval(timeInterval);
		}
		
		if ( timeData.days === 0 )
		{
			hideDaysCell();
			displaySecondsCell();
		}
		
		daysValueNode.textContent = formatTimeValue( timeData.days );
		daysKeyNode.textContent = pluralNumber( timeData.days, `день`, `дня`, `дней` );
		
		hoursValueNode.textContent = formatTimeValue( timeData.hours );
		hoursKeyNode.textContent = pluralNumber( timeData.hours, `час`, `часа`, `часов` );
		
		minutesValueNode.textContent = formatTimeValue( timeData.minutes );
		minutesKeyNode.textContent = pluralNumber( timeData.minutes, `минута`, `минуты`, `минут` );
		
		secondsValueNode.textContent = formatTimeValue( timeData.seconds );
		secondsKeyNode.textContent = pluralNumber( timeData.seconds, `секунда`, `секунды`, `секунд` );
		
		adjustFontSize();
	};
	
	const timeInterval = setInterval(updateTimer, 1000);
	
	oldNode.replaceWith( container );
	
	updateTimer();
	
	window.addEventListener( `resize`, handleChangeSize );
};
